import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ctaClickEvent, pageViewEvent } from "../services/adobeDataLayer";

function Thankyou() {
  const navigate = useNavigate();
  useEffect(() => {
    //Trigger ADL on Thank you page load
    pageViewEvent("thank you");

    if (window.gtag) {
      // Google Ads conversion event
      window.gtag("config", "AW-818835661");
      window.gtag("event", "conversion", {
        send_to: "AW-818835661/RXCQCOzD_pYbEM3huYYD",
      });

      //Invmedia TY page
      window.gtag("event", "conversion", {
        allow_custom_scripts: true,
        send_to: "DC-8971752/invmedia/icici01z+unique",
      });
    }

    // FB events
    if (window.fbq) {
      window.fbq("trackSingle", "1584375811875352", "PLCC-TY");
      window.fbq("trackSingleCustom", "1109423764622443", "PLCC-TY"); // For both pixel IDs
    }

    // const loadFbqScript = () => {
    //   return new Promise((resolve) => {
    //     if (window.fbq) return resolve(); // Already loaded
    //     (function (f, b, e, v, n, t, s) {
    //       if (f.fbq) return;
    //       n = f.fbq = function () {
    //         n.callMethod
    //           ? n.callMethod.apply(n, arguments)
    //           : n.queue.push(arguments);
    //       };
    //       if (!f._fbq) f._fbq = n;
    //       n.push = n;
    //       n.loaded = true;
    //       n.version = "2.0";
    //       n.queue = [];
    //       t = b.createElement(e);
    //       t.async = true;
    //       t.src = v;
    //       s = b.getElementsByTagName(e)[0];
    //       s.parentNode.insertBefore(t, s);
    //       t.onload = resolve;
    //     })(
    //       window,
    //       document,
    //       "script",
    //       "https://connect.facebook.net/en_US/fbevents.js"
    //     );
    //   });
    // };

    // const initializePixels = () => {
    //   if (!window.fbq) return;

    //   // Initialize both pixels
    //   window.fbq("init", "1584375811875352"); // Pixel A
    //   window.fbq("init", "1109423764622443"); // Pixel B
    //   // Send PageView only to each separately (to avoid duplication)
    //   // window.fbq("trackSingle", "1584375811875352", "PageView");
    //   // window.fbq("trackSingleCustom", "1109423764622443", "PageView");
    //   window.fbq("trackSingle", "1584375811875352", "PLCC-TY");
    //   window.fbq("trackSingleCustom", "1109423764622443", "PLCC-TY");
    // };

    // loadFbqScript().then(() => {
    //   initializePixels();
    // });
  }, []);

  useEffect(() => {
    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", "tqjggh89an");
  }, []);

  const handleClick = () => {
    navigate("/");
    ctaClickEvent("Back", "Thank you page", "button", 0, "na");
  };

  return (
    <>
      <div className="container">
        <button onClick={handleClick} className="free_back thank_you_back">
          <img
            src={process.env.PUBLIC_URL + "/dist/img/back_white.svg"}
            width="12"
            alt="<"
          />
          Back
        </button>
      </div>
      <article className="thank-you ">
        <div className="container">
          <div className="popup-icon">
            <img
              src={process.env.PUBLIC_URL + "/dist/img/thank-you.svg"}
              alt="tick"
              width={100}
              height={100}
              className="img-fluid"
            />
          </div>
          <div className="thankyou_txt">
            <h2>Thank you</h2>
            <p>
              {" "}
              for choosing to apply for a
              Personal&nbsp;Loan&nbsp;on&nbsp;Credit&nbsp;Card. <br />
              We are evaluating your profile, and our team will reach out to you
              shortly.
            </p>

            <p className="subtext">
              The eligible offer amount will be communicated over the call.
              <br />
              We request you to keep your phone available for this conversation.
              Our representative will get in touch with you shortly from a number starting with 1600 31 XXXX.
            </p>
          </div>
        </div>
      </article>
    </>
  );
}

export default Thankyou;
